import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { Lock } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/auth/login`, { email, password });
      localStorage.setItem("vd_token", data.token);
      localStorage.setItem("vd_name", data.name);
      navigate("/admin");
    } catch (err) {
      const d = err.response?.data?.detail;
      setError(typeof d === "string" ? d : "Accesso non riuscito");
    } finally {
      setLoading(false);
    }
  };

  const inputCls =
    "w-full bg-transparent border-b border-black/20 py-3 text-base font-light focus:border-black focus:outline-none transition-colors duration-300";

  return (
    <div data-testid="admin-login-page" className="min-h-screen flex items-center justify-center px-6 bg-[#FAFAFA]">
      <div className="w-full max-w-sm">
        <Link to="/" className="font-serif text-2xl tracking-tight block mb-2">
          VETRO <span className="text-champagne">DESIGN</span>
        </Link>
        <div className="flex items-center gap-2 mb-10 text-muted-foreground">
          <Lock strokeWidth={1} className="w-4 h-4" />
          <p className="text-xs uppercase tracking-[0.3em]">Area Riservata</p>
        </div>

        <form onSubmit={submit} className="space-y-8">
          <input
            data-testid="login-email"
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className={inputCls}
          />
          <input
            data-testid="login-password"
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className={inputCls}
          />
          {error && (
            <p data-testid="login-error" className="text-sm text-destructive">{error}</p>
          )}
          <button
            type="submit"
            data-testid="login-submit"
            disabled={loading}
            className="w-full bg-black text-white py-4 text-sm uppercase tracking-wide hover:bg-black/80 transition-colors disabled:opacity-50"
          >
            {loading ? "Accesso..." : "Accedi"}
          </button>
        </form>
      </div>
    </div>
  );
}
